import React from "react";
import "./Meaning.css";
import Synonyms from "./Synonyms";

export default function Meaning(props) {
  return (
    <section>
      <div className="Meaning">
        <h3>{props.meaning.partOfSpeech}</h3>

        <p>{props.meaning.definition}</p>

        <Synonyms synonyms={props.meaning.synonyms} />
      </div>
    </section>
  );
}
